import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Styling/Invoice.css";
import { getInvoiceData } from '../Api/ViewPostedInvoice';
import { Base_URL } from "../url";
import { useReactToPrint } from "react-to-print";
import { fetchOrgHsn } from "../Api/IncomingPo";

const CreditNotePrintHeader=({invoiceData})=>{
      const location = useLocation();
      
      // const [invoiceData, setInvoiceData] = useState({});
      const [count, setCount] = useState("");
        const invoiceId = location.pathname.split("/")[2];
        
// useEffect(() => {
//     const fetchInvoiceData = async () => {
//       const res = await getInvoiceData(invoiceId);
//       console.log(res, 'res dngjf jhjkdt hjkt');
//       setInvoiceData(res)
//       setCount(res?.items?.length)
      
//     }
//     fetchInvoiceData()
//   }, [])

  return(
    <header>

            {/* <!-- Header --> */}
            {invoiceData?.invoice?.invoicePosted === 'Yes' ? (
            <div className="invoice-header">CREDIT NOTE</div>
            ) : (
                <div className="invoice-header">
              {invoiceData?.invoice?.cancelled_Indicator === "Yes"
                ? invoiceData?.invoice?.transactionType === "Debit Note"
                  ? "Cancelled Debit Note"
                  : "Cancelled Credit Note"
                : invoiceData?.invoice?.transactionType === "Debit Note"
                  ? "Pro-Forma Debit Note"
                  : "Pro-Forma Credit Note"}
            </div>
            )}

            {/* <!-- Company Section --> */}
            <div className="company-section">
              <div className="logo-section">
                <div className="logo">
                  <img src={invoiceData?.company?.logoUrl} className="img-fluid" />
                </div>
              </div>

              <div className="company-details">
                <div className="company-name">{invoiceData?.company?.name}</div>
                <div className="company-info">
                  {invoiceData?.office?.address1}<br />
                  {invoiceData?.office?.address2}<br />
                  {invoiceData?.office?.address3}<br />
                  {invoiceData?.city?.description} - {invoiceData?.office?.pincode}
                </div>
              </div>

              <div className="invoice-details">
                <div className="invoice-grid">
                  <ul className="invoice-lists">
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">GSTIN NO.</span>
                        <span>{invoiceData?.office?.gstin}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">STATE OF SALE.</span>
                        <span>{invoiceData?.city?.region}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">CIN NO.</span>
                        <span>{invoiceData?.company?.cinNumber}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">Company Code:</span>
                        <span>{invoiceData?.company?.companyCode}</span>
                      </div>
                    </li>
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">Email.</span>
                        <span> {invoiceData?.office?.emailId}</span>
                      </div>
                    </li>
                  </ul>
                  <ul className="invoice-lists">
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">{invoiceData?.invoice?.transactionType === "Debit Note"?"DEBIT NOTE NO.":"CREDIT NOTE NO."} </span>
                        <span>{invoiceData?.invoice?.invoicePosted == 'Yes' ? invoiceData?.invoice?.invoiceNumber : invoiceId}</span>
                      </div>
                    </li>
                    {/* <li>
                    <div className="invoice-item">
                      <span className="invoice-label">E-INVOICE ACK NO.</span>
                      <span>{invoiceData?.invoice?.einvIrn}</span>
                    </div>
                  </li> */}
                    <li>
                      {/* <div className="invoice-item">
                        <span className="invoice-label">E-Way Bill No.</span>
                        <span>{invoiceData?.dispatch?.ewayBillNumber}</span>
                      </div> */}
                    </li>
                    <li>
                      {/* <div className="invoice-item">
                        <span className="invoice-label">DUE DATE</span>
                        <span>{invoiceData?.invoice?.dueDate
                      ? invoiceData.invoice.dueDate.split("T")[0].split("-").reverse().join("-")
                           : ""}
                      </span>
                      </div> */}
                    </li>
                    <li>
                      {/* <div className="invoice-item">
                        <span className="invoice-label">STORE TRN NO.</span>
                        <span>{invoiceData?.invoice?.storeTrn}</span>
                      </div> */}
                    </li>
                    <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">INVOICE NO.</span>
                        <span>{invoiceData?.invoice?.invoiveNumber}</span>
                    
                      </div>
                    </li>
                        <li>
                      <div className="invoice-item1">
                        <span className="invoice-label">Posting Date.</span>
                        <span>{invoiceData?.invoice?.invoiceDate
                          ? invoiceData.invoice.invoiceDate.split('T')[0].split("-").reverse().join("-")
                           : ""}</span>
                      </div>
                    </li>
                  </ul>

                  <ul className="invoice-lists">
                
                    {/* <li>
                    <div className="invoice-item">
                      <span className="invoice-label">E_INV DATE.</span>
                      <span>{invoiceData?.invoice?.einvDate?.split("T")[0]}</span>
                    </div>
                  </li> */}
                    <li>
                      {/* <div className="invoice-item">
                        <span className="invoice-label">EWAY BILL DATE.</span>
                        <span>{invoiceData?.dispatch?.ewayBillDate
                            ? invoiceData.dispatch.ewayBillDate.split("T")[0].split("-").reverse().join("-") : ""}
                        </span>
                      </div> */}
                    </li>
                    <li>
                      {/* <div className="invoice-item">
                        <span className="invoice-label">STORE TRN DATE.</span>
                        <span>{invoiceData?.invoice?.ewaybDate
                            ? invoiceData.invoice.ewaybDate.split("T")[0].split("-").reverse().join("-")
                            : ""}
                            </span>
                      </div> */}
                    </li>

                    <li>
                      {/* <div className="invoice-item">
                        <span className="invoice-label">CUST PO DATE.</span>
                        <span>{invoiceData?.invoice?.custpoDate
                            ? invoiceData.invoice.custpoDate.split("T")[0].split("-").reverse().join("-")
                            : ""}
                            </span>
                      </div> */}
               <div >
                <div className="section-title">CUSTOMER DETAILS:</div>
                <div><b>{invoiceData?.customer?.name}</b></div>
                <br />
                <div>{invoiceData?.customer?.address1}, {invoiceData?.customer?.address2}<br />
                  {invoiceData?.customer?.address3} {invoiceData?.customer?.pinCode}</div>
                <div>{invoiceData?.region?.region}</div>
                <br />
                <div className="details-grid">
                  <span className="label">PLACE OF SUPPLY & STATE CODE</span>
                  <span>: {invoiceData?.region?.region}, {invoiceData?.region?.regionCode}</span>
                  <span className="label">GSTIN NO.</span>
                  <span>: {invoiceData?.customer?.gstno}</span>
                  <span className="label">PAN NO.</span>
                  <span>: {invoiceData?.customer?.pan}</span>
                </div>
              </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* <!-- Customer and Delivery Section --> */}
            {/* <div className="customer-section"> */}
              {/* <div className="customer-details"> */}
                {/* <div className="section-title">CUSTOMER DETAILS:</div>
                <div><b>{invoiceData?.customer?.name}</b></div>
                <br />
                <div>{invoiceData?.customer?.address1}, {invoiceData?.customer?.address2}<br />
                  {invoiceData?.customer?.address3} {invoiceData?.customer?.pinCode}</div>
                <div>{invoiceData?.region?.region}</div>
                <br />
                <div className="details-grid">
                  <span className="label">PLACE OF SUPPLY & STATE CODE</span>
                  <span>: {invoiceData?.region?.region}, {invoiceData?.region?.regionCode}</span>
                  <span className="label">GSTIN NO.</span>
                  <span>: {invoiceData?.customer?.gstno}</span>
                  <span className="label">PAN NO.</span>
                  <span>: {invoiceData?.customer?.pan}</span>
                </div>
              </div> */}

              {/* <div className="delivery-details">
                <div className="section-title">ADDRESS OF DELIVERY</div>
                <div>{invoiceData?.shipping?.name}</div>
                <br />
                <div>{invoiceData?.shipping?.address1}, {invoiceData?.shipping?.address2}</div>

                <div>{invoiceData?.deliveryAdress?.description}</div>
                <div>{invoiceData?.shipping?.address3}</div>
                <div>GSTIN NO. : {invoiceData?.customer?.gstno}</div>
              </div> */}
              {/* <div className="delivery-details">
                <div className="right-section">
                  <div className="right-item">
                    <span className="right-label">TYPE OF SALE</span>
                    <span>{invoiceData?.supply?.supplyTypeDescription}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>{invoiceData?.invoice?.custpoDate
  ? invoiceData.invoice.custpoDate.split("T")[0].split("-").reverse().join("-")
  : ""}
</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">PLACE OF SALE</span>
                    <span>Intrastate</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">CUST. ORDER NO.</span>
                    <span>{invoiceData?.invoice?.purchaseOrder}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">L.R. NO.</span>
                    <span>{invoiceData?.dispatch?.lrNumber}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DATE</span>
                    <span>{invoiceData?.dispatch?.lrDate
                            ? invoiceData.dispatch.lrDate.split("T")[0].split("-").reverse().join("-")
                            : ""}
                            </span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DISPATCH DATE</span>
                    <span>
                    </span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">CASES</span>
                    <span>0</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">TRANSPORTER NAME</span>
                    <span>{invoiceData?.dispatch?.transporterName}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">TRANSPORT MODE</span>
                    <span>{invoiceData?.dispatch?.transportMode}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">DESTINATION</span>
                    <span>{invoiceData?.dispatch?.destination}</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label"></span>
                    <span></span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">PAYMENT TERMS</span>
                    <span>-</span>
                  </div>
                  <div className="right-item">
                    <span className="right-label">VEHICLE NO.</span>
                    <span>{invoiceData?.dispatch?.vehicleNumber}</span>
                  </div>
                </div>
              </div> */}
            {/* </div> */}
          </header>
  )
}

export default CreditNotePrintHeader;